import i18n from "../../i18n";

// Secure Files — utilitaires navigateur : lien (clé dans le fragment uniquement), nom de fichier sûr, mailto local.

const PATH_RE = /^\/f\/[A-Za-z0-9_-]{20,}$/;
const KEY_RE = /^[A-Za-z0-9_-]{43}$/; // 32 octets base64url sans padding

// Lien complet construit LOCALEMENT : chemin renvoyé par le serveur (sans clé) + « #k=<clé> ».
export function buildShareLink(origin, publicPath, key) {
  if (!PATH_RE.test(publicPath || "") || !KEY_RE.test(key || "")) throw new Error("invalid_link_parts");
  return `${origin}${publicPath}#k=${key}`;
}

// Lit la clé depuis location.hash uniquement (jamais depuis la query string ni le chemin).
export function readKeyFromHash(hash) {
  const m = /^#k=([A-Za-z0-9_-]+)$/.exec(hash || "");
  return m && KEY_RE.test(m[1]) ? m[1] : null;
}

const MAX_NAME = 150;
export const FALLBACK_NAME = "securepass-file";

// Nom de téléchargement sûr : jamais manifest.name brut (traversal, séparateurs, contrôles, NUL, longueur).
export function sanitizeFilename(name) {
  let s = typeof name === "string" ? name.normalize("NFC") : "";
  s = s.replace(/[\u0000-\u001f\u007f-\u009f]/g, "");
  s = s.split(/[/\\]/).pop();
  s = s.replace(/[<>:"|?*]/g, "_").replace(/^[.\s]+/, "").replace(/[.\s]+$/, "");
  if (s.length > MAX_NAME) {
    const dot = s.lastIndexOf(".");
    const ext = dot > 0 && s.length - dot <= 16 ? s.slice(dot) : "";
    s = s.slice(0, MAX_NAME - ext.length) + ext;
  }
  return s || FALLBACK_NAME;
}

// mailto: entièrement côté navigateur (aucun appel API : ni destinataire, ni lien, ni clé ne quittent le poste).
export function buildMailto({ to = "", subject, body }) {
  return `mailto:${encodeURIComponent(to.trim()).replace(/%40/g, "@")}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}

// Téléchargement local : Blob opaque (application/octet-stream), jamais d'affichage inline ni ouverture d'onglet.
export function triggerLocalDownload(bytes, filename) {
  const url = URL.createObjectURL(new Blob([bytes], { type: "application/octet-stream" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = sanitizeFilename(filename);
  a.rel = "noopener";
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export function formatBytes(n, lng) {
  const u = (k) => i18n.t(`files:units.${k}`);
  for (const [k, v] of [["MiB", 1024 * 1024], ["KiB", 1024]]) {
    if (n >= v) return `${new Intl.NumberFormat(lng, { maximumFractionDigits: 1 }).format(n / v)} ${u(k)}`;
  }
  return `${new Intl.NumberFormat(lng).format(n)} ${u("B")}`;
}
